import { markCompanySelected, beginContextSwitch } from "./auth-session";

/** Cambio de sociedad iniciado por usuario: persiste tenant y va a home. */
export function switchCompany(companyId: string): void {
  const current = localStorage.getItem("selectedCompanyId");
  if (!companyId || companyId === current) return;

  beginContextSwitch();
  localStorage.setItem("selectedCompanyId", companyId);
  markCompanySelected();
  window.location.replace("/");
}
